import { Directive, ElementRef, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/prevent-autofocus.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class PreventAutofocusDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.storedValue = elementRef.nativeElement.tabIndex;
        elementRef.nativeElement.tabIndex = -1;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (this.elementRef.nativeElement.tabIndex == -1)
                this.elementRef.nativeElement.tabIndex = this.storedValue;
        }), 1500);
    }
}
PreventAutofocusDirective.ɵfac = function PreventAutofocusDirective_Factory(t) { return new (t || PreventAutofocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PreventAutofocusDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PreventAutofocusDirective, selectors: [["", "egovPreventAutofocus", ""]] });
/** @nocollapse */
PreventAutofocusDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PreventAutofocusDirective, [{
        type: Directive,
        args: [{
                selector: '[egovPreventAutofocus]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    PreventAutofocusDirective.prototype.storedValue;
    /**
     * @type {?}
     * @private
     */
    PreventAutofocusDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/prevent-autofocus.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreventAutofocusModule {
}
PreventAutofocusModule.ɵfac = function PreventAutofocusModule_Factory(t) { return new (t || PreventAutofocusModule)(); };
PreventAutofocusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PreventAutofocusModule });
PreventAutofocusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PreventAutofocusModule, [{
        type: NgModule,
        args: [{
                declarations: [PreventAutofocusDirective],
                imports: [],
                exports: [PreventAutofocusDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PreventAutofocusModule, { declarations: [PreventAutofocusDirective], exports: [PreventAutofocusDirective] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-prevent-autofocus.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PreventAutofocusModule, PreventAutofocusDirective as ɵa };

